import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('Verifying your email...');
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setError('Verification token is missing.');
      setStatus('');
      return;
    }

    fetch('/.netlify/functions/verify-email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token })
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setStatus('Email successfully verified! Redirecting to login...');
          setTimeout(() => navigate('/'), 3000);
        } else {
          setError(data.error || 'Verification failed.');
          setStatus('');
        }
      })
      .catch(err => {
        setError('Network error during verification.');
        setStatus('');
      });
  }, [searchParams, navigate]);

  return (
    <div style={{ maxWidth: '400px', margin: '80px auto', padding: '30px', textAlign: 'center', fontFamily: 'Arial, sans-serif', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', borderRadius: '8px' }}>
      <h2>Account Email Verification</h2>
      {status && <p style={{ color: '#0056b3', fontWeight: 'bold' }}>{status}</p>}
      {error && <p style={{ color: '#d9534f', fontWeight: 'bold' }}>{error}</p>}
    </div>
  );
}